import styled from 'styled-components'
import { Colors } from '../../constants'

export const Button = styled.button`
  white-space: nowrap;
  border: 1px solid ${Colors.Black};
  background-color: ${Colors.White};
  outline: none;
  padding: 6px 12px;
  cursor: pointer;
`
